(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbElementGenerator', fbElementGeneratorDirective);

    function fbElementGeneratorDirective() {
        return {
            restrict: 'EA',
            scope: {
                fbElement: '=',
                formIdentifier: '=',
                elementIdentifier: '=',
                renderedElements: '=',
                model: '=',
                refreshElement: '=?',
                templates: '=?',
                disable: '=?'
            },
            controller: fbElementGeneratorDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbElementGeneratorDirectiveCtrl(FormBuilderService, $compile, $element, $scope, lodash, $timeout, CommonHelper) {
        var cloneElement;
        var vm = this;
        var type, template;
        var showIfTemplate = false;

        this.$onInit = function() {
            vm.currentElement = angular.copy(vm.fbElement);

            vm.isEmpty = CommonHelper.isEmpty;

            if (vm.disable && vm.disable === true) {
                vm.currentElement.attr.disabled = true;
            }

            vm.currentElement.refreshElement = refreshElement;
            // console.log(vm.fbElement.name, ',', vm.elementIdentifier);
            vm.currentElement.elementIdentifier = vm.elementIdentifier;
            FormBuilderService.sync(vm.formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger;
            vm.refreshElement = refreshElement;


            showIfTemplate = (lodash.has(vm, 'fbElement.showIf')) ? 'ng-show="vm.showFunc(vm.currentElement)"' : "";

            handleElementOptions();

            switch (vm.currentElement.type) {
                case "subform":
                    template = contructSubFormTemplate();
                    break;
                case "subform-selection":
                    template = contructSubFormSelectionTemplate();
                    break;
                case "custom":
                    template = constructCustomTemplate();
                    break;
                case "anchor":
                case "button":
                    template = constructButtonTemplate(vm.currentElement.type);
                    break;
                case "hidden":
                    template = constructHiddenTemplate();
                    break;
                case "settings-button":
                case "settings-toggle":
                case "settings-text":
                case "settings-select":
                    template = constructSettingsTemplate();
                    break;
                case "template":
                case "compile":
                    template = constructTemplateFieldTemplate();
                    break;
                // case "display-only":
                //     template = constructDisplayOnlyFieldTemplate();
                //     break;

                default:
                    template = constructDefaultTemplate();
                    break;
            }

            compileTemplate();
            $scope.$on('$destroy', scopeDestroy);
        }

        function compileTemplate() {
            $element.html(template);
            cloneElement = $compile($element.contents())($scope);
        }

        function refreshElement() {
            cloneElement.off();
            $element.empty();
            $timeout(function () {
                compileTemplate();
            }, 200);
        }

        function constructDefaultTemplate() {
            var settings_attr = '';

            setDefaultModel(vm.currentElement.type);

            vm.renderedElements[vm.currentElement.name] = vm.currentElement;

            type = getElementType(vm.currentElement.type);
            let labelType = "fb-label";
            
            if (['field-radio-checkbox', 'field-checkbox-button', 'field-toggle'].indexOf(type) >= 0) {
                labelType = "fb-label-right";
            }

            if (['field-select', 'field-timeslotpicker',
                'field-daterangepicker', 'field-rankchoice', 'field-two-level-selector'

            ].indexOf(type) >= 0) {
                labelType = "fb-label-div";
            }

            if ([
                'field-employment-type-details',
            ].indexOf(type) >= 0) {
                labelType = "fb-label-no-error";
            }

            if (['field-skillset-manager', 'field-datatable-toggle-manager'].indexOf(type) >= 0) {
                labelType = "fb-label-div-no-msg";
            }

            if (['field-image', 'field-duration', 'field-approver-selector', 'field-signer-details'].indexOf(type) >= 0) {
                labelType = 'fb-label-text';
            }

            let modelStringType = vm.currentElement.type;
            if (lodash.get(vm.fbElement, 'options.settings_type', null)) {
                settings_attr = getSettingFieldsAttr(type);
                modelStringType = 'settings-field';
                type = 'settings-field';
            }

            var templateUrl = '';
            if (lodash.has(vm.currentElement,  'options.templateUrl')) {
                templateUrl = 'template="' + vm.currentElement.options.templateUrl + '"';
            }

            const modelString = constructModelString(modelStringType);
            var mainTemplate = '<fb-' + type + ' element="vm.currentElement" options="vm.currentElement.options" ' + modelString + ' class="field-element" event-handler="vm.onEventTrigger(type)"' +
                getTemplateAttr(vm.currentElement.type) +
                settings_attr + ' ' + templateUrl +
                '></fb-' + type + '>';



            if (type === 'settings-field') {
                return mainTemplate;
            } else {
                var hideIfEmptySetting = '';

                if (lodash.get(vm.currentElement, 'options.hide_if_empty', false)) {
                    hideIfEmptySetting = 'ng-if="!vm.isEmpty(vm.model[vm.currentElement.name])"';
                }

                return '' +
                    '<' + labelType + ' ' + showIfTemplate + ' element="vm.currentElement" ng-class="vm.currentElement.attr.labelClass" element-identifier="vm.elementIdentifier" ' + hideIfEmptySetting + '>' +
                    mainTemplate +
                    '</' + labelType + '>';
            }
        }

        function constructNgModelTemplate() {

        }

        function constructHiddenTemplate() {
            vm.renderedElements[vm.currentElement.name] = vm.currentElement;
            return '<fb-field-hidden element="vm.currentElement" options="vm.currentElement.options" model="vm.model[vm.currentElement.name]" ></fb-field-hidden>';
        }

        function constructTemplateFieldTemplate() {
            return '<fb-field-' + vm.currentElement.type + ' element="vm.currentElement"></fb-field-' + vm.currentElement.type + '>';
        }

        function constructButtonTemplate(type) {
            return '<fb-field-' + type + ' ' + showIfTemplate + ' element="vm.currentElement" class="small"></fb-field-' + type + '>';
        }

        function constructCustomTemplate() {
            type = lodash.get(vm, 'fbElement.name', '');
            return '<' + type + ' ' + showIfTemplate + ' element="vm.currentElement" model="vm.model"></' + type + '>';
        }

        function constructModelString(type) {
            switch (type) {
                case "smart-text-element":
                    return 'model="vm.model[vm.currentElement.name].value"';
                case 'settings-field':
                case 'tag':
                case 'autocomplete':
                case 'skillset-manager':
                case 'toggle':
                case 'file-upload':
                case 'approver-selector':
                case 'datatable-toggle-manager':
                case "employment-type-details":
                case 'datepicker':
                case 'datepicker2':
                case 'signer-details':
                    return 'ng-model="vm.model[vm.currentElement.name]"';
                default:
                    return 'model="vm.model[vm.currentElement.name]"';
            }
        }

        function contructSubFormTemplate() {
            var subfieldType = lodash.get(vm, 'fbElement.subfields.type', 'form');

            if (subfieldType == 'group') {
                if (!lodash.has(vm.model, vm.currentElement.name)) {
                    vm.model[vm.currentElement.name] = {};
                }
                vm.renderedElements[vm.currentElement.name] = {};
            } else {
                if (!lodash.has(vm.model, vm.currentElement.name)) {
                    vm.model[vm.currentElement.name] = [];
                }
                vm.renderedElements[vm.currentElement.name] = [];
            }

            return '<fb-subform-' + subfieldType + ' ' + showIfTemplate + '  fb-element="vm.currentElement" rendered-elements="vm.renderedElements[vm.currentElement.name]" class="section" model="vm.model[vm.currentElement.name]"></fb-subform>';
        }

        function contructSubFormSelectionTemplate() {
            var subfieldType = lodash.get(vm, 'fbElement.subfields.type', 'form');

            // if (subfieldType == 'group') {
            //     if (!lodash.has(vm.model, vm.currentElement.name)) {
                    vm.model[vm.currentElement.name] = {};
                // }
                // vm.renderedElements[vm.currentElement.name] = {};
            // } else {
            //     if (!lodash.has(vm.model, vm.currentElement.name)) {
            //         vm.model[vm.currentElement.name] = [];
            //     }
            //     vm.renderedElements[vm.currentElement.name] = [];
            // }

            return '<fb-subform-' + subfieldType + ' ' + showIfTemplate + '  fb-element="vm.currentElement" rendered-elements="vm.renderedElements[vm.currentElement.name]" class="section" model="vm.model[vm.currentElement.name]"></fb-subform>';
        }

        function scopeDestroy() {
            cloneElement.off();
        }

        function getElementType(type) {
            switch (type) {
                case "checkbox":
                case "radio":

                    return "field-radio-checkbox";
                case "textbox":
                    return "field-textfield";
                case "text":
                case "number":
                case "email":
                case "password":
                case "tel":
                case "search":
                case "smart-text-element":
                    return "field-simple";
                case "remote-select":
                    return "field-select";
                case "checkbox-button":
                    return "field-checkbox-button";
                case "color-picker":
                // return "field" + type;
                case "display-only":
                default:
                    return "field-" + type;
            }
        }

        function setDefaultModel(type) {
            if (!lodash.has(vm.model, vm.currentElement.name)) {
                switch (type) {
                    case "file":
                    case "file-upload":
                        if (lodash.get(vm.currentElement, 'options.multiple', false)) {
                            lodash.set(vm.model, vm.currentElement.name, []);
                        } else {
                            lodash.set(vm.model, vm.currentElement.name, {});
                        }
                        break
                    case "yesno":
                    case "singlechoice":
                    case "singlechoicedropdown":
                    case "multichoice":
                    case "freetext":
                    case "image":
                    case "timeslotpicker":
                    case "daterangepicker":
                    case "settings-button":
                    case "duration":
                    case "approver-selector":
                    case "signer-details":
                    case "interview-medium-selector":
                    case "two-level-selector":

                        lodash.set(vm.model, vm.currentElement.name, {});
                        break;
                    case "settings-select":
                    case "tag":
                    case "skillset-manager":
                    case "employment-type-details":
                        lodash.set(vm.model, vm.currentElement.name, []);
                        break;
                    case "settings-toggle":
                    case "checkbox-button":
                    case "toggle":

                        lodash.set(vm.model, vm.currentElement.name, false);
                        break;
                    case "checkbox-qn":
                        lodash.set(vm.model, vm.currentElement.name + ".answer", false);
                        break;
                    case "number":
                        lodash.set(vm.model, vm.currentElement.name, 0);
                        break;
                    case "text":
                    case "email":
                    case "password":
                    case "textbox":
                    case "date":
                    case "captcha":
                    case "tel":
                    case "search":
                    case "settings-text":
                    case "display-only":
                    case "video-url":
                    case "email-verify-element":
                        lodash.set(vm.model, vm.currentElement.name, '');
                        break;
                    case "smart-text-element":
                        lodash.set(vm.model, vm.currentElement.name, {value: null});
                        break;
                    case "dropdown-qn":
                        lodash.set(vm.model, vm.currentElement.name, null);
                        break;
                }
            }
        }

        function constructSettingsTemplate() {
            setDefaultModel(vm.currentElement.type);
            var type = 'fb-field-' + vm.currentElement.type;
            return '<' + type + ' element="vm.currentElement" model="vm.model[vm.currentElement.name]"></' + type + '>';
        }

        function handleElementOptions() {
            var prefix = lodash.get(vm.model, [vm.currentElement.name, 'prefix'].join('.'), null);
            if (prefix) {
                lodash.set(vm.currentElement, 'attr.prefix.value', prefix);
            }
            var suffix = lodash.get(vm.model, [vm.currentElement.name, 'suffix'].join('.'), null);
            if (suffix) {
                lodash.set(vm.currentElement, 'attr.suffix.value', suffix);
            }
        }

        function getTemplateAttr(type) {
            if (lodash.isEmpty(vm.templates)) {
                return '';
            }

            var templateValue = lodash.get(vm.templates, type, '');

            var templateValueOverride = lodash.get(vm, 'currentElement.options.templateUrl');
            if (templateValueOverride) {
                templateValue = templateValueOverride;
            }

            return ' template="' + templateValue + '" ';
        }

        function getSettingFieldsAttr(type) {
            var settings_type = lodash.get(vm.fbElement, 'options.settings_type', null);
            if (!settings_type) {
                return '';
            }

            return ' field-type="' + type + '" ';
        }
    }
})();
